import { isNativeApp } from 'infra/services/native-bridge';
import {
	getViewportWidth,
	resolveSurface,
	type Surface,
} from 'infra/services/surface/resolveSurface';

type ClientContext = {
	is_native_app: boolean;
	surface: Surface;
	viewport_width?: number;
};

export const buildClientContext = (): ClientContext => {
	const viewportWidth = getViewportWidth();

	return {
		is_native_app: isNativeApp(),
		surface: resolveSurface(),
		...(viewportWidth !== null && { viewport_width: viewportWidth }),
	};
};
